import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class LivePlayerController extends BridgeComponent {
  static component = "live-player";

  connect() {
    // Installs the library's native:restore listener, which re-runs connect() (re-sending
    // this payload) when the native shell restores the screen without a Turbo visit.
    super.connect();

    this.send("connect", {
      itemId: this.element.getAttribute("data-item-id"),
      itemType: this.element.getAttribute("data-item-type"),
      title: this.element.getAttribute("data-title"),
      streamType: "live",
      hlsUrl: this.element.getAttribute("data-hls-url"),
      // IVS validates the token only at playback initiation, so a running session
      // outlives this moment - native uses it purely to decide whether re-initiating
      // a failed session needs a page reload (fresh token) first.
      expiresAtMs: Number(this.element.getAttribute("data-hls-url-expires-at-ms")),
    });
  }

  disconnect() {
    // When the stream ends, the page's turbo_stream_from subscription re-renders it as
    // not-live, so this disconnect doubles as native's stream-ended teardown signal.
    this.send("disconnect");
    super.disconnect();
  }
}
